








































































































import { Component, Prop, Vue, Watch, Mixins } from 'vue-property-decorator'
import TaskApi from '@/api/task'
import BillApi from '@/api/bill2'
import { TOKEN, SO_FAR } from '@/store/mutation-types'
import PageLayout from '@/components/page/PageLayout.vue'
import {
	uuid,
	dateFormat,
	throttle,
	download,
	triggerWindowResizeEvent,
} from '@/utils/util'
import moment from 'moment'
import EvaluateApi from '@/api/evaluate'
import Task from '@/web-task'
import cloneDeep from 'lodash/cloneDeep'
import { initOrderDetail } from '@/web-task/utils/order'
import { wsURL } from '@/api/url'
import setting from '@/core/setting'
import InvestigateApi from '@/api/investigate'
import Info from '@/components/task/Info.vue'
import InfoRow from '@/views/AiiTasks/InfoRow.vue'
import { formatTime, formatDate, format } from '@/web-task/filter'
import { zeroUnit } from '@/web-task/utils'
import Bubble from '@/components/Bubble.vue'
import addTaskMixin from './addTaskMixin'
import Upload from '@/components/Upload/index.vue'
const PIAO_JU_JIE_XI = '13'
const PIAO_JU_CHA_XUN = '6'
const PIAO_JU_YAN_ZHENG = '7'
const grsbpc = 20
const zdjzpc = 21
const jzgjpc = 22
const payerPartyTypeMap: any = {
	'1': '个人',
	'2': '单位',
}

Component.registerHooks([
	'beforeRouteEnter',
	'beforeRouteUpdate',
	'beforeRouteLeave',
])

@Component({
	name: 'bill2TaskEdit',
	components: {
		PageLayout,
		Info,
		InfoRow,
		Bubble,
		Upload,
	},
})
export default class TaskEdit extends Mixins(addTaskMixin) {
	private exporting: boolean = false
	private importing: boolean = false
	private active: any = 0
	private baseInfo: any = {}
	private results: any = []
	private riskContent: any = ''
	private illSuspected: any = ''
	private submitMsg: any = ''
	private resultsEmpty: boolean = false
	totalSearch: any = 0
	currSearch: any = 0
	private columns1: any = [
		{
			title: '序号',
			align: 'center',
			dataIndex: 'index',
			width: 20,
			customRender: (text: any, record: any, index: any) => index + 1,
		},
		{
			title: '就诊日期',
			align: 'center',
			dataIndex: 'visitDate',
			scopedSlots: { customRender: 'visitDate' },
			width: 150,
		},
		{
			title: '就诊类型',
			align: 'center',
			dataIndex: 'visitType',
			width: 150,
		},
		{
			title: '就诊医院',
			align: 'center',
			dataIndex: 'hospital',
			width: 100,
		},
		{
			title: '就诊科室',
			align: 'center',
			dataIndex: 'department',
			width: 100,
		},
		{
			title: '总金额',
			align: 'center',
			dataIndex: 'amount',
			width: 150,
		},
		{
			title: '疑似诊断',
			align: 'center',
			dataIndex: 'illSuspected',
			width: 150,
		},
	]
	private columns2: any = [
		{
			title: '序号',
			align: 'center',
			dataIndex: 'key',
			width: 20,
			customRender: (text: any, record: any, index: any) => index + 1,
		},
		{
			title: '就诊日期',
			align: 'center',
			dataIndex: 'visitDate',
			scopedSlots: { customRender: 'visitDate' },
			width: 150,
		},
		{
			title: '就诊类型',
			align: 'center',
			dataIndex: 'visitType',
			width: 150,
		},
		{
			title: '就诊医院',
			align: 'center',
			dataIndex: 'hospital',
			width: 100,
		},
		{
			title: '就诊科室',
			align: 'center',
			dataIndex: 'department',
			width: 100,
		},
		{
			title: '总金额',
			align: 'center',
			dataIndex: 'amount',
			width: 150,
		},
	]

	private queryInfo: any = {}
	private authInfo: any = {}

	private downloadTemplate() {
		const a = document.createElement('a')
		if (this.isKeyVisits) {
			a.href = '/重点就诊排查.xlsx'
			a.download = '重点就诊排查.xlsx'
		} else if (this.isVisitTrajectory) {
			a.href = '/就诊轨迹排查.xlsx'
			a.download = '就诊轨迹排查.xlsx'
		}
		a.click()
		a.remove()
	}

	private init() {
		this.baseInfo = {}
		this.results = []
		this.getDetail()
	}

	private activated() {
		this.init()
	}

	private zeroUnit(val: string, unit: string) {
		return zeroUnit(val, unit)
	}

	private handleOk() {
		const data = {
			orderId: this.$route.params.orderId,
			results: this.results,
			riskContent: this.riskContent,
			illSuspected: this.illSuspected,
		}
		BillApi.editBosssoftTask(data).then((res: any) => {
			this.$message.success('提交成功')

			this.$multiTab.closeCurrentPage()
			setTimeout(() => {
				this.$multiTab.open('/bill2/taskList')
			}, 1000)
		})
	}

	private beforeRouteUpdate(to: any, from: any, next: any) {
		this.$nextTick(() => {
			this.init()
		})
		next()
	}

	private get isVisitTrajectory() {
		// 伤病推断
		return this.$route.params.taskType === '22'
	}

	private get isPersonalInjury() {
		// 伤病推断
		return this.$route.params.taskType === '20'
	}

	private get isKeyVisits() {
		// 伤病推断
		return this.$route.params.taskType === '21'
	}

	public submit() {
		if (!this.riskContent) {
			this.$message.error('请输入风险提醒信息')
			return
		}

		if (this.isPersonalInjury && !this.illSuspected) {
			this.$message.error('请输入伤病推断信息')
			return
		}

		this.resultsEmpty =
			(this.isKeyVisits || this.isVisitTrajectory) && this.results.length <= 0
		if (this.resultsEmpty) {
			this.submitMsg = '查询结果列表为空，确认提交吗？'
		} else {
			this.submitMsg = '数据已填写，确认提交吗？'
		}

		let passConfirm = this.$confirm({
			title: '提示',
			content: this.submitMsg,
			onOk: () => {
				const data = {
					orderId: this.$route.params.orderId,
					results: this.results,
					riskContent: this.riskContent,
					illSuspected: this.illSuspected,
				}
				BillApi.editBosssoftTask(data).then((res: any) => {
					this.$message.success('提交成功')

					this.$multiTab.closeCurrentPage()
					setTimeout(() => {
						this.$multiTab.open('/bill2/taskList')
					}, 1000)
				})
			},
		})
	}

	private async importData() {
		const res = await (this.$refs.upload as any).getSingle()
		const formData = new FormData()
		formData.append('file', res)
		formData.append('orderId', this.$route.params.orderId)

		let detailPromise = BillApi.importBosssoftTask(formData)
		this.importing = true
		return detailPromise.then(
			(res: any) => {
				this.$message.success('导入成功')
				this.importing = false
				this.results = res.data
			},
			err => {
				this.importing = false
			}
		)
	}

	private getDetail() {
		let detailPromise = BillApi.getBosssoftDetail(this.$route.params.orderId)
		return detailPromise.then((res: any) => {
			const baseInfo = res.data.baseInfo
			this.baseInfo = res.data.baseInfo
			this.results = []
			this.riskContent = !res.data.riskContent ? '' : res.data.riskContent
			this.illSuspected = !res.data.illSuspected ? '' : res.data.illSuspected
			this.currSearch = !res.data.currSearch ? '0' : res.data.currSearch
			this.totalSearch = !res.data.totalSearch ? '0' : res.data.totalSearch
			this.active = 0
			let arr: any = [
				{ label: '查询公司', value: baseInfo.companyName },
				{ label: '订单号', value: baseInfo.orderNo },
				{ label: '查询时间', value: formatTime(baseInfo.createTime) },
				{ label: '查询人', value: baseInfo.creatorName },
				{
					label: '查询类型',
					value: this.$store.state.setting.einvoiceTasktypeMap[
						baseInfo.taskType
					],
				},
				{
					label: '查询状态',
					value: this.$store.state.setting.invoiceTaskStatusMap[
						baseInfo.orderStatus
					],
				},
				{ label: '中保运营专员姓名', value: baseInfo.operatorName },
				{ label: '中保运营专员电话', value: baseInfo.operatorMobile },
				{ label: '就诊人姓名', value: baseInfo.patientName },
				{ label: '就诊人身份证号', value: baseInfo.idCard },
				{ label: '日期', value: formatDate(baseInfo.insDate) },
			]
			if (baseInfo.taskType === grsbpc) {
				arr.push({ label: '疑似伤病', value: baseInfo.injuryIll })
			}
			if (baseInfo.taskType === zdjzpc) {
				arr.push(
					{
						label: '险种',
						value: this.$store.state.setting.einsTypeMap[
							baseInfo.insuranceType
						],
					},
					{ label: '疑似伤病', value: baseInfo.injuryIll }
				)
			}
			arr.push({
				label: '授权文件',
				value: baseInfo.authorizeInfoUrl,
				slot: 'url',
			})
			const queryInfo = {
				title: '查询信息',
				children: arr,
			}
			for (const item of queryInfo.children) {
				if (!item.value) {
					item.value = '-- / --'
				}
			}
			this.queryInfo = queryInfo
		})
	}
}
